import { usePendingState } from 'providers/PendingProvider';
import { Modal, ModalProps } from 'reactstrap';
import 'scss/Main.scss';

export type BaseModalProps = Omit<ModalProps, 'toggle'> & {
    toggle: React.KeyboardEventHandler<any> | React.MouseEventHandler<any>;
    trigger?: 'unfocus' | 'manual';
};

const BaseModal = ({ children, toggle, trigger = 'manual', ...props }: BaseModalProps) => {
    const { showPending } = usePendingState();

    return (
        <Modal
            toggle={(e: any) => {
                if (trigger === 'manual') {
                    e.keyCode === 27 && toggle(e);
                } else toggle(e);
            }}
            {...props}
        >
            {showPending && <div className="ui-block"></div>}
            {children}
        </Modal>
    );
};

export default BaseModal;
